import React from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import get from "lodash/get";
import { Select, NumberField, Fieldset } from "react95";
import { updateSearchFilterCondtion, updateSearchFilterSize } from "../../reducers/searchFilters";
import useSelectedScraper from "../../hooks/useSelectedScraper";

const Container = styled.div`
    width: 55%;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const Fields = styled.div`
    display: flex;
    flex-direction: column;
`;

const FieldContainer = styled.div`
    display: flex;
    align-items: center;

    @media (max-width: 768px) {
        flex-wrap: wrap;
    }
`;

const AdvancedField = styled.div`
    width: 70%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const Label = styled.label`
    width: 28%;
    margin-right: 2px;
    text-align: right;

    @media (max-width: 768px) {
        text-align: left;
        width: 100%;
    }
`;

const AdvancedSearch = () => {
    const dispatch = useDispatch();
    const selectedScraper = useSelectedScraper();

    const filters = useSelector((state) => get(state, `searchFilters.${selectedScraper}`, []));

    const filterConditions = [
        { value: "SELECT", label: "Select" },
        { value: "AT_LEAST", label: "AT LEAST" },
        { value: "EQUAL_TO", label: "EQUAL TO" }
    ];
    return (
        <Container>
            <Fieldset label="Advanced Fields">
                <Fields>
                    {filters.map((filter) => (
                        <FieldContainer key={selectedScraper + filter.name}>
                            <Label>{filter.name} must be:&nbsp;</Label>
                            <AdvancedField>
                                <Select
                                    key={selectedScraper + filter.index}
                                    width="50%"
                                    shadow={false}
                                    selectedIndex={filter.index}
                                    items={filterConditions}
                                    onChange={(value) => {
                                        const conditionIndex = filterConditions.findIndex(
                                            (filterCondition) => filterCondition.value === value
                                        );
                                        dispatch(
                                            updateSearchFilterCondtion(
                                                filter.name,
                                                value,
                                                conditionIndex
                                            )
                                        );
                                    }}
                                    style={{ marginRight: 5 }}
                                />
                                <NumberField
                                    width="50%"
                                    shadow={false}
                                    value={filter.size}
                                    onChange={(value) => {
                                        dispatch(updateSearchFilterSize(filter.name, value));
                                    }}
                                />
                            </AdvancedField>
                        </FieldContainer>
                    ))}
                </Fields>
            </Fieldset>
        </Container>
    );
};

export default AdvancedSearch;
